import { useState, useEffect } from "react";
import { Row, Col, message } from "antd";
import { admin_dashboardApi, all_ga4_propertiesApi, get_user_according_to_date_rangeApi, get_ai_usage_stats } from "../api/admin.apis";
import { DashboardCards } from "./../components/home/DashboardCards";
import { ChartsSection } from "./../components/home/ChartsSection";
import { ProjectsTable } from "./../components/home/ProjectsTable";
import { OrdersTimeline } from "./../components/home/OrdersTimeline";
// import { InfoCards } from "./../components/home/InfoCards";
import { LoadingState } from "./../components/home/LoadingState";
import { ErrorState } from "./../components/home/ErrorState";
import { getIcons } from "./../components/home/Icons";

function Home() {
  const [dashboardData, setDashboardData] = useState(null);
  const [ga4Properties, setGa4Properties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showGa4Details, setShowGa4Details] = useState(false);
  const [activeUsersByDate, setActiveUsersByDate] = useState([]);
  const [aiUsageData, setAiUsageData] = useState(null);
  const [showAiOverallDetails, setShowAiOverallDetails] = useState(false);
  const [showAiProviderDetails, setShowAiProviderDetails] = useState(false);
  const [showAiModelDetails, setShowAiModelDetails] = useState(false);
  const [showAiFeatureDetails, setShowAiFeatureDetails] = useState(false);
  const [showAiInternalDetails, setShowAiInternalDetails] = useState(false);
  const [showAiCustomerDetails, setShowAiCustomerDetails] = useState(false);
  const icons = getIcons();

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  useEffect(() => {
    const startDate = "2026-01-12"; // example start
    const endDate = "2026-01-16";   // example end

    Promise.all([
      fetchDashboardData(),
      fetchGa4Properties(),
      fetchActiveUsers(startDate, endDate),
      fetchAiUsageStats(),
    ]).finally(() => setLoading(false));
  }, []);


  const fetchDashboardData = async () => {
    try {
      const response = await admin_dashboardApi();
      if (response.data.status === "success") {
        setDashboardData(response.data.data);
      } else {
        setError("Failed to fetch dashboard data");
        message.error("Failed to load dashboard data");
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError(err.message || "An error occurred");
      message.error("Error loading dashboard data");
    }
  };

  const fetchGa4Properties = async () => {
    try {
      const response = await all_ga4_propertiesApi();
      if (response.data.status === "success") {
        setGa4Properties(response.data.data);
      } else {
        console.error("Failed to fetch GA4 properties:", response.data.message);
        message.warning("Could not load GA4 properties");
      }
    } catch (err) {
      console.error("Error fetching GA4 properties:", err);
      message.warning("Error loading GA4 properties");
    }
  };
  const fetchAiUsageStats = async () => {
    try {
      const response = await get_ai_usage_stats();
      if (response.data.status === "success") {
        setAiUsageData(response.data.data);
      } else {
        console.error("Failed to fetch AI usage stats:", response.data.message);
      }
    } catch (err) {
      console.error("Error fetching AI usage stats:", err);
    }
  };

  const fetchActiveUsers = async (startDate, endDate) => {
    try {
      const response = await get_user_according_to_date_rangeApi(startDate, endDate);
      if (response.data.status === "success") {
        // Transform data into ApexCharts format
        const chartData = response.data.data.map(item => ({
          date: item.date,
          users: item.unique_active_users
        }));
        setActiveUsersByDate(chartData);
      } else {
        console.error("Failed to fetch active users:", response.data.message);
      }
    } catch (err) {
      console.error("Error fetching active users:", err);
    }
  };

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchDashboardData} />;
  }

  return (
    <div className="layout-content">
      <DashboardCards
        dashboardData={dashboardData}
        showGa4Details={showGa4Details}
        setShowGa4Details={setShowGa4Details}
        icons={icons}
        aiUsageData={aiUsageData}
        showAiOverallDetails={showAiOverallDetails}
        setShowAiOverallDetails={setShowAiOverallDetails}
        showAiProviderDetails={showAiProviderDetails}
        setShowAiProviderDetails={setShowAiProviderDetails}
        showAiModelDetails={showAiModelDetails}
        setShowAiModelDetails={setShowAiModelDetails}
        showAiFeatureDetails={showAiFeatureDetails}
        setShowAiFeatureDetails={setShowAiFeatureDetails}
        showAiInternalDetails={showAiInternalDetails}
        setShowAiInternalDetails={setShowAiInternalDetails}
        showAiCustomerDetails={showAiCustomerDetails}
        setShowAiCustomerDetails={setShowAiCustomerDetails}
      />

      <ChartsSection activeUsersByDate={activeUsersByDate} /> {/* pass data */}

      <Row gutter={[24, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={16} className="mb-24">
          <ProjectsTable
            onChange={onChange}
            ga4Properties={ga4Properties}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8} className="mb-24">
          <OrdersTimeline />
        </Col>
      </Row>

      {/* <InfoCards /> */}
    </div>
  );
}

export default Home;